import { useState } from 'react';
import { useGenericModal } from '..';
import {
  DeleteProviderModal,
  DeleteProviderModalProps,
} from './delete-provider-modal';

export const useDeleteProviderModal = (
  props?: Partial<DeleteProviderModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const [connectionName, setConnectionName] =
    useState<DeleteProviderModalProps['connectionName']>('');

  const modalComponent = (
    <DeleteProviderModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
      connectionName={connectionName}
    />
  );

  const openDeleteProviderModal = (
    name: DeleteProviderModalProps['connectionName']
  ) => {
    setConnectionName(name);
    openModal();
  };

  return {
    modalRef,
    openModal: openDeleteProviderModal,
    closeModal,
    deleteProviderModal: modalComponent,
  };
};
